import { Entity, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { HeaderTableau } from './header-tableau.entity';

@Entity('tableau_plage_horaire')
export class TableauPlageHoraire {
    @PrimaryGeneratedColumn()
    id: number;

    @OneToMany(() => HeaderTableau, (header: HeaderTableau) => header.tableauPlageHoraire, { cascade: true })
    headers: HeaderTableau[];
}
